import React, {useEffect, useState} from "react";
import {IRouteParams} from "../../../contracts/router";
import {useLocation, useParams} from "react-router-dom";
import {ISectionPageComponent} from "../../../contracts/pages";
import PanelMainInner from "../../PanelMainInner";
import FilesForCategoryInVideoProductsList from "./FilesForCategoryInVideoProductsList";
import CreateOrUpdateFileForCategoryInVideoProductForm from "./CreateOrUpdateFileForCategoryInVideoProductForm";


const FilesForCategoryInVideoProductsSections:React.FC = () => {
    const params:IRouteParams = useParams();
    const [type, setType] = useState<string>("list")
    const location = useLocation()

    const sectionPageComponent:ISectionPageComponent = {
        "undefined": <FilesForCategoryInVideoProductsList />,
        "list": <FilesForCategoryInVideoProductsList />,
        "create": <CreateOrUpdateFileForCategoryInVideoProductForm />,
        "edit": <CreateOrUpdateFileForCategoryInVideoProductForm />,
        // "videos-products": <VideosProductsInCategory />,
        // "files": <CreateOrUpdateCategoryForVideoProductForm />,
    }

    useEffect(() => {
        setType(params.type!)
    }, [params.type])

    return(
        <PanelMainInner title={"فایل ها"} isBtn={type === 'list'} isBg={true} btnTxt={"فایل جدید"} btnLinkProps={{
            pathname: "/dashboard/files-categories/create",
            state: {page: location.pathname, page_num: 1}
        }}>
            {sectionPageComponent[type]}
        </PanelMainInner>
    )
}

export default FilesForCategoryInVideoProductsSections